function getStyle(el) {
  return el.currentStyle || window.getComputedStyle(el);
}

export default getStyle;



// WEBPACK FOOTER //
// ./utils/getStyle.js